import{createContext}from'react';/**
 * Internal, exported only for usage in Framer
 */var SwitchLayoutGroupContext=createContext({});export{SwitchLayoutGroupContext};